import { render, staticRenderFns } from "./storeServe.vue?vue&type=template&id=a266f164&scoped=true"
import script from "./storeServe.vue?vue&type=script&lang=js"
export * from "./storeServe.vue?vue&type=script&lang=js"
import style0 from "./storeServe.vue?vue&type=style&index=0&id=a266f164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a266f164",
  null
  
)

export default component.exports